import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
	GotoPreviousPageOnRightSidebar,
	NavigateToSidebarPage,
	SetRightSidebarInitialComponent,
} from '@layout/state/layout.actions';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { take, filter } from 'rxjs';
import {
	rightSidebarComponentContext,
	rightSideBarNavigation,
} from '../state/layout.selectors';
import { IRightSidebarNavigation } from '../state/layout.reducer';
import { ISidebarConfig } from '@layout/au-right-sidebar/right-sidebar.interfaces';
import { RightSidebarAliasesEnum } from '@layout/au-right-sidebar/au-right-sidebar-component-aliases';
import { NewWorkOrderComponent } from '@app/pages/cmms/components/work-order/new-work-order/new-work-order.component';
import { EditWorkOrderComponent } from '@app/pages/cmms/components/work-order/edit-work-order/edit-work-order.component';
import { NewRequestComponent } from '@app/pages/cmms/components/request/new-request/new-request.component';
import { NewIncidentComponent } from '@app/pages/cmms/components/incident/new-incident/new-incident.component';
import { EditIncidentComponent } from '@app/pages/cmms/components/incident/edit-incident/edit-incident.component';
import { NewAssetComponent } from '@app/pages/cmms/components/assets/new-asset/new-asset.component';
import { EditAssetComponent } from '@app/pages/cmms/components/assets/edit-asset/edit-asset.component';
import { EditFileEntityComponent } from '@app/pages/cmms/components/files/edit-file-entity/edit-file-entity.component';
import { EntityAttachmentTableComponent } from '@app/pages/cmms/components/entity-attachment-table/entity-attachment-table.component';
import { EditRequestComponent } from '@app/pages/cmms/components/request/edit-request/edit-request.component';
import { NewMessageComponent } from '@app/pages/messages/components/new-message/new-message.component';

@Injectable({
	providedIn: 'root',
})
export class RightSidebarNavigationService {
	constructor(private store$: Store) {}

	get navigationData() {
		return this.store$.select(rightSideBarNavigation).pipe(take(1));
	}

	get pageContext() {
		return this.store$.select(rightSidebarComponentContext).pipe(take(1));
	}

	setInitialComponent(config: Partial<IRightSidebarNavigation>) {
		this.store$.dispatch(
			SetRightSidebarInitialComponent({
				config: { ...config },
			})
		);
	}

	navigateTo(page: CmmsPages, config: Partial<ISidebarConfig> = {}) {
		this.store$.dispatch(NavigateToSidebarPage({ page, config }));
	}

	navigateToPreviousPage() {
		this.store$.dispatch(GotoPreviousPageOnRightSidebar());
	}

	getInitialFormValueByPage(page: CmmsPages) {
		return this.store$.select(rightSideBarNavigation).pipe(
			take(1),
			filter(sideBar => !!sideBar.formValue && sideBar.initialPage === page)
		);
	}

	getComponentByAlias(alias: RightSidebarAliasesEnum) {
		const RightSidebarAliases = {
			newWorkOrder: NewWorkOrderComponent,
			editWorkOrder: EditWorkOrderComponent,
			newRequest: NewRequestComponent,
			editRequest: EditRequestComponent,
			newIncident: NewIncidentComponent,
			editIncident: EditIncidentComponent,
			newAsset: NewAssetComponent,
			editAsset: EditAssetComponent,
			editFile: EditFileEntityComponent,
			attachExisting: EntityAttachmentTableComponent,
			messages: NewMessageComponent,
		};

		if (!RightSidebarAliases[alias]) {
			throw new Error('Get Component By Alias could not find component');
		}

		return RightSidebarAliases[alias];
	}
}
